import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";
import { useShallow } from "zustand/react/shallow";

export const useRenderCheckReservationOverviewSubmit = () => {
  const { cartAccommodationItems, rootAttributes } = useEngineStore(
    useShallow((state) => ({
      cartAccommodationItems: state.cartAccommodationItems,
      rootAttributes: state.rootAttributes,
    })),
  );

  const hasAccTypesForPaymentInCart =
    !!rootAttributes[RootAttribute.AccommodationTypesForPayment]?.length &&
    cartAccommodationItems.every(
      (item) =>
        rootAttributes[RootAttribute.AccommodationTypesForPayment]?.includes(
          item.rateGroup.accommodationType!.code,
        ),
    );

  const hasAccTypeCategoriesForPaymentInCart =
    !!rootAttributes[RootAttribute.RateGroupsForPayment]?.length &&
    cartAccommodationItems.every(
      (item) => rootAttributes[RootAttribute.RateGroupsForPayment]?.includes(item.rateGroup.code),
    );

  return { hasAccTypesForPaymentInCart, hasAccTypeCategoriesForPaymentInCart };
};
